export default class {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    /**
     * 
     * @param {{name: string}} options 
     * @returns 
     */
    create(options){
        return this.client.post(`/form-completions`, options)
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/formCompletion.js